export const firebaseConfig = {
  apiKey: "AIzaSyCCebpjlmtX2lM2X_iKLIWTxEQdh4Z8AY8",
  authDomain: "screens-d2639.firebaseapp.com",
  databaseURL: "https://screens-d2639.firebaseio.com",
  projectId: "screens-d2639",
  storageBucket: "",
  messagingSenderId: "277478107320",
  appId: "1:277478107320:web:d47db0494e43213aa4ec4d",
}
